/**
 * @file getConfig.js
 *
 * Because this file is consumed from next.config.js this can't
 * have newer javascript functionality as it will not be parsed from babel or webpack.
 *
 * see https://nextjs.org/docs/api-reference/next.config.js/introduction
 */
let appConfig = require('./../../../config/app');

/**
 * Get the current frontend folder key.
 *
 * The folder keys is used in config but its also the folder that will be created inside the build dir
 * for the final production build.
 */
const getFrontendFolderKey = (frontendKey = '') => {
  const frontend = frontendKey ? frontendKey : 'default';
  let frontendFolderKey = 'default';
  if (frontend !== appConfig.public.FRONTENDS.default) {
    frontendFolderKey = frontend;
  }
  return frontendFolderKey;
};

/**
 * Gets a configuration object from the /config for the current frontend.
 *
 * @param {string} config
 *   The config file to return.
 */
const getFrontendConfig = (config, frontendKey = '') => {
  const frontend = frontendKey ? frontendKey : 'default';
  // Get the right key for the current frontend.
  let frontendFolderKey = getFrontendFolderKey(frontendKey);
  // Get the config that was asked for.
  let returnConfig = require(`./../../../config/${config}`);

  // Check if the current frontend has a specific config.
  try {
    returnConfig = require(`./../../../config/${frontendFolderKey}/${config}`);
  } catch {}

  return returnConfig;
};

module.exports = {
  getFrontendFolderKey,
  getFrontendConfig,
};
